var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-form-group',{attrs:{"title":_vm.$t(_vm.field)}},[_c('t-text-input',{attrs:{"value":_vm.formatedValue,"placeholder":_vm.$t('notRegistered'),"width":"100%","disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }